/* lv-mua-hang.js — 26/10/2026 (sua-mua-hang-2610). Mọi khối bọc try/catch: lỗi thì bỏ khối đó, không làm hỏng trang. */
(() => {
  'use strict';
  const root = document.documentElement;
  const AS02_CHART = 'https://cdn.shopify.com/s/files/1/0971/4171/9406/files/photo_2026-09-10_16-00-56.jpg?v=1789030954';

  /* 1. Chat Shopify + thẻ "10% off": nâng lên trên thanh Add to cart dính (CSS biến --lv-lift ở lv-mua-hang.css) */
  const SHADOW = {
    'SHOPIFY-CHAT': '.activator-nudge{translate:0 calc(var(--lv-lift,0px) * -1);transition:translate .25s ease}',
    'SHOPIFY-FORMS-EMBED': '#app-embed[data-current-step="tease"]{bottom:var(--lv-lift,0px)!important;transition:bottom .25s ease}'
  };
  const TARGET = { 'SHOPIFY-CHAT': '.activator-nudge', 'SHOPIFY-FORMS-EMBED': '#app-embed' };
  const deepRoots = host => {   // chat Shopify lồng nhiều tầng shadow DOM (shopify-chat > shopify-agent-runtime > nút Chat)
    const out = [];
    const walk = r => { out.push(r); r.querySelectorAll('*').forEach(e => { if (e.shadowRoot) walk(e.shadowRoot); }); };
    if (host.shadowRoot) walk(host.shadowRoot);
    return out;
  };
  const inject = () => {
    try {
      Object.keys(SHADOW).forEach(tag => {
        document.querySelectorAll(tag.toLowerCase()).forEach(el => {
          deepRoots(el).forEach(sr => {
            if (sr.querySelector(TARGET[tag]) && !sr.querySelector('style[data-lv-lift]')) {
              const st = document.createElement('style');
              st.setAttribute('data-lv-lift', '');
              st.textContent = SHADOW[tag];
              sr.appendChild(st);
            }
          });
        });
      });
    } catch (e) { /* bỏ qua */ }
  };
  let ticks = 0;
  const timer = setInterval(() => { inject(); if (++ticks > 120) clearInterval(timer); }, 1000);
  inject();

  /* 2. Ngăn giỏ mở -> thêm class lv-cart-open lên <html> */
  const watchDrawer = () => {
    try {
      const d = document.querySelector('m-cart-drawer');
      if (!d) return;
      const sync = () => root.classList.toggle('lv-cart-open', d.classList.contains('m-cart-drawer--active'));
      new MutationObserver(sync).observe(d, { attributes: true, attributeFilter: ['class'] });
      sync();
    } catch (e) { /* bỏ qua */ }
  };

  /* 3. Nút dính / nút chính: chưa chọn đủ Type + Size thì ghi "Choose size" thay vì "Unavailable" */
  const pickerIncomplete = () => {
    const picker = document.querySelector('product-info variant-picker');
    if (!picker) return false;
    return [...picker.querySelectorAll('[data-picker-field="radio"]')].some(f => !f.querySelector('input:checked'));
  };
  const fixLabels = () => {
    try {
      document.querySelectorAll('[name="add"] .m-add-to-cart--text').forEach(el => {
        if (el.textContent.trim() !== 'Unavailable') return;
        const scope = el.closest('sticky-atc') || el.closest('form') || el.closest('.m-product-form');
        const id = scope && scope.querySelector('[name="id"]');
        if (pickerIncomplete() || !id || !id.value) el.textContent = 'Choose size';
      });
    } catch (e) { /* bỏ qua */ }
  };
  const watchLabels = () => {
    try {
      fixLabels();
      document.querySelectorAll('sticky-atc, .m-product-form--main').forEach(t =>
        new MutationObserver(fixLabels).observe(t, { subtree: true, childList: true, characterData: true }));
    } catch (e) { /* bỏ qua */ }
  };

  /* 4. Mở bằng ?variant= thì ảnh đầu phải là ảnh của biến thể đó (khung ảnh gốc của theme; trang vịt/Hydrangea/Ruffle dùng lv-r12 riêng) */
  const variantImage = () => {
    try {
      if (!/[?&]variant=/.test(location.search)) return;
      if (document.querySelector('lv-r12-gallery')) return;
      customElements.whenDefined('product-info').then(() => {
        const go = () => {
          const pi = document.querySelector('product-info');
          if (pi && pi.currentVariant && typeof pi.updateMedia === 'function') pi.updateMedia(pi.currentVariant);
        };
        if (document.readyState === 'complete') setTimeout(go, 400);
        else window.addEventListener('load', () => setTimeout(go, 400));
      });
    } catch (e) { /* bỏ qua */ }
  };

  /* 5. Mallard "Ruffle - Camo": bảng size = bảng AS02 của vịt Ruffle (S-XXL), không phải bảng Short */
  const ruffleChart = () => {
    try {
      customElements.whenDefined('lv-r12-gallery').then(() => {
        const C = customElements.get('lv-r12-gallery');
        if (!C || C.prototype.__lvRuffle) return;
        const orig = C.prototype.guide;
        C.prototype.__lvRuffle = true;
        C.prototype.guide = function () {
          orig.apply(this, arguments);
          try {
            if (/^ruffle/i.test(String(this.type)) && !this.data.ownChart) {
              const img = this.modal.querySelector('.lv-r12-chart img');
              if (img) {
                img.src = AS02_CHART;
                img.alt = 'AS02 original size chart in inches, S to XXL';
                const p = this.modal.querySelector('[data-r12-content] p');
                if (p) p.textContent = 'Original AS02 size chart · Inches';
              }
            }
          } catch (e) { /* bỏ qua */ }
        };
      });
    } catch (e) { /* bỏ qua */ }
  };

  /* 6. Ngăn giỏ: gợi ý mẫu bán chạy (HTML do snippets/lv-cart-bundle.liquid dựng), chọn size Short rồi Add ngay trong ngăn giỏ */
  const bundle = () => {
    try {
      if (customElements.get('lv-cart-bundle')) return;
      class LvCartBundle extends HTMLElement {
        connectedCallback() {
          if (this.ready) return;
          this.ready = true;
          this.addEventListener('change', e => {
            const s = e.target.closest('[data-size]');
            if (s) s.closest('.lv-cb-card').querySelector('[data-add]').disabled = !s.value;
          });
          this.addEventListener('click', e => {
            const b = e.target.closest('[data-add]');
            if (b && !b.disabled) this.add(b);
          });
        }
        async json(url, options) {
          const r = await fetch(url, { credentials: 'same-origin', ...options });
          const data = await r.json();
          if (!r.ok || data.status >= 400) throw new Error(data.description || 'Please try again.');
          return data;
        }
        async add(btn) {
          const card = btn.closest('.lv-cb-card');
          const sel = card.querySelector('[data-size]');
          const status = card.querySelector('[data-status]');
          const id = Number(sel.value);
          if (!id || this.busy) return;
          this.busy = true;
          btn.disabled = true; sel.disabled = true; btn.textContent = 'Adding…'; status.textContent = '';
          let attempted = false;
          const base = (this.dataset.root || '/').replace(/\/?$/, '/');
          try {
            let sections = ['cart-drawer', 'cart-count'];
            root.dispatchEvent(new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections } }));
            sections = [...new Set(sections)];
            if (sections.length > 5) throw new Error('Please refresh your bag first.');
            attempted = true;
            const added = await this.json(base + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: JSON.stringify({ items: [{ id, quantity: 1 }], sections, sections_url: location.pathname })
            });
            const current = await this.json(base + 'cart.js');
            current.sections = added.sections;
            if (!current.sections || !current.sections['cart-drawer'] || !current.sections['cart-count']) {
              current.sections = await this.json(base + '?' + sections.map(x => 'sections[]=' + encodeURIComponent(x)).join('&'));
            }
            if (!current.sections['cart-drawer'] || !current.sections['cart-count']) throw new Error('Bag display could not refresh.');
            window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, { cart: current, productVariantId: String(id) });
          } catch (err) {
            status.textContent = attempted ? 'Please check your bag before trying again.' : err.message;
            if (attempted) btn.textContent = 'Check your bag';
          } finally {
            this.busy = false;
            if (this.isConnected && !attempted) { sel.disabled = false; btn.disabled = !sel.value; btn.textContent = 'Add short set'; }
          }
        }
      }
      customElements.define('lv-cart-bundle', LvCartBundle);
    } catch (e) { /* bỏ qua */ }
  };

  const start = () => { watchDrawer(); watchLabels(); variantImage(); ruffleChart(); bundle(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
